import React from 'react';
import { FileText, Folder, Search, Upload, Download, Eye, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Documents() {
  const folders = [{
    id: 1,
    name: 'Committee Charters',
    count: 12
  }, {
    id: 2,
    name: 'Meeting Minutes',
    count: 35
  }, {
    id: 3,
    name: 'Policies & Procedures',
    count: 18
  }, {
    id: 4,
    name: 'Reports & Presentations',
    count: 24
  }];
  const documents = [{
    id: 1,
    name: 'Finance Committee Charter.pdf',
    type: 'PDF',
    size: '2.4 MB',
    uploadedBy: 'Mohammed Al Hashimi',
    date: '2023-08-15'
  }, {
    id: 2,
    name: 'HR Committee Meeting Minutes - August.docx',
    type: 'DOCX',
    size: '1.8 MB',
    uploadedBy: 'Aisha Al Mansoori',
    date: '2023-08-10'
  }, {
    id: 3,
    name: 'IT Security Policy 2023.pdf',
    type: 'PDF',
    size: '3.2 MB',
    uploadedBy: 'Omar Al Shamsi',
    date: '2023-08-05'
  }, {
    id: 4,
    name: 'Q2 Performance Report.xlsx',
    type: 'XLSX',
    size: '4.5 MB',
    uploadedBy: 'Fatima Al Zaabi',
    date: '2023-07-28'
  }, {
    id: 5,
    name: 'Committee Structure Overview.pptx',
    type: 'PPTX',
    size: '6.7 MB',
    uploadedBy: 'Ahmed Al Dhaheri',
    date: '2023-07-20'
  }];
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'PDF':
        return <FileText size={16} className="text-red-500" data-id="element-1154" />;
      case 'DOCX':
        return <FileText size={16} className="text-blue-500" data-id="element-1155" />;
      case 'XLSX':
        return <FileText size={16} className="text-green-500" data-id="element-1156" />;
      case 'PPTX':
        return <FileText size={16} className="text-orange-500" data-id="element-1157" />;
      default:
        return <FileText size={16} className="text-gray-500" data-id="element-1158" />;
    }
  };
  return <div data-id="element-1159">
      <div className="flex justify-between items-center mb-6" data-id="element-1160">
        <h1 className="text-2xl font-bold" data-id="element-1161">Document Library</h1>
        <Link to="/documents/add" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors flex items-center" data-id="element-1162">
          <Upload size={18} className="mr-2" data-id="element-1163" />
          Upload Document
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6" data-id="element-1164">
        {folders.map(folder => <div key={folder.id} className="bg-white p-6 rounded-lg shadow-sm flex items-center" data-id="element-1165">
            <div className="bg-orange-100 p-3 rounded-full mr-4" data-id="element-1166">
              <Folder size={24} className="text-orange-500" data-id="element-1167" />
            </div>
            <div data-id="element-1168">
              <h3 className="font-medium" data-id="element-1169">{folder.name}</h3>
              <p className="text-sm text-gray-500" data-id="element-1170">{folder.count} files</p>
            </div>
          </div>)}
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1171">
        <div className="flex justify-between items-center mb-6" data-id="element-1172">
          <h2 className="text-lg font-semibold" data-id="element-1173">Recent Documents</h2>
          <div className="relative" data-id="element-1174">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-1175" />
            <input type="text" placeholder="Search documents..." className="pl-10 pr-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-1176" />
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1177">
          <table className="w-full" data-id="element-1178">
            <thead data-id="element-1179">
              <tr className="bg-gray-50" data-id="element-1180">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1181">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1182">
                  Size
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1183">
                  Uploaded By
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1184">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1185">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1186">
              {documents.map(document => <tr key={document.id} data-id="element-1187">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1188">
                    <div className="flex items-center" data-id="element-1189">
                      {getFileIcon(document.type)}
                      <span className="ml-2 font-medium text-gray-900" data-id="element-1190">
                        {document.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1191">
                    <div className="text-sm text-gray-500" data-id="element-1192">{document.size}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1193">
                    <div className="text-sm text-gray-500" data-id="element-1194">
                      {document.uploadedBy}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1195">
                    <div className="text-sm text-gray-500" data-id="element-1196">{document.date}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1197">
                    <div className="flex space-x-3" data-id="element-1198">
                      <button className="text-blue-500 hover:text-blue-700" data-id="element-1199">
                        <Eye size={16} data-id="element-1200" />
                      </button>
                      <button className="text-green-500 hover:text-green-700" data-id="element-1201">
                        <Download size={16} data-id="element-1202" />
                      </button>
                      <button className="text-red-500 hover:text-red-700" data-id="element-1203">
                        <Trash2 size={16} data-id="element-1204" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}